import { GitBranch } from 'lucide-react'
import type { NodeProps } from '@xyflow/react'
import { NodeShell } from './nodeTypes'
import type { FlowNode } from './nodeTypes'

export function BranchNode({ data, selected }: NodeProps<FlowNode>) {
  return (
    <NodeShell
      icon={GitBranch}
      label={data.label}
      sublabel="Branch"
      accentColor="#eab308"
      selected={selected}
      diamond
    />
  )
}
